import { inject, Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { Observable } from 'rxjs';
import { Response } from 'src/app/types';
import { UserInfo } from 'src/app/types/user.type';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private restApiService = inject(RestApiService);

  userInfo(): Observable<Response<UserInfo>> {
    return this.restApiService.get(environment.api_url + '/customer/user');
  }

  updateUserInfo(sendEmail: boolean): Observable<Response<void>> {
    return this.restApiService.post(environment.api_url + '/customer/user', {
      sendEmailNotification: sendEmail,
    });
  }
}
